import { type AppDispatch } from "features/Application/globaltypes/redux";
import DataService from "features/Application/services/dataServices/typedDataService";
import { errFeedbackPage, gotFeedbackPage, reqFeedbackPage } from "../slices/feedbackPageSlice";

export const getFeedbackPage = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(reqFeedbackPage());
  try {
    const result = await DataService.threatDefence.campaigns.getFeedbackPage(id);
    dispatch(gotFeedbackPage(result.data));
  } catch (error) {
    dispatch(errFeedbackPage(error));
  }
};
